import React, { useState } from 'react';
import Button from '@Components/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import { createTheme, MuiThemeProvider } from '@material-ui/core/styles';
import { Close } from '@material-ui/icons';
import {
	DialogTitle, IconButton,
} from '@material-ui/core';
import moment from 'moment';
import HighlightTabs from '@Components/HighlightTabs';

const tabslist = [
	{ label: 'Part A', value: 1 },
	{ label: 'Part B1', value: 2 },
	{ label: 'Part B2', value: 3 },
	{ label: 'Part C', value: 4 },
	{ label: 'Part D', value: 5 },
	{ label: 'Part E', value: 6 },
];

export default ({
	open, selected, setSelected,
}) => {
	const [tab, setTab] = useState(1);

	if (!selected) return (<></>);
	const handleClose = () => setSelected();
	return (
		<MuiThemeProvider theme={getMuiTheme()}>
			<Dialog maxWidth="md" fullWidth open={open} onClose={handleClose}>
				<DialogTitle className="py-1">
					<div className="d-flex justify-content-between align-items-center">
						NCR Report Detail
						<IconButton onClick={handleClose}>
							<Close />
						</IconButton>
					</div>
					<div className="d-flex justify-content-between mb-1" style={{ fontSize: 16 }}>
						<div>
							<p className="font-weight-bold mt-2" style={{ color: 'black' }}>Reference Number By</p>
							<p className="text-muted">{selected.refferenceNumber}</p>
						</div>
						<div>
							<p className="font-weight-bold mt-2" style={{ color: 'black' }}>Created By</p>
							<p className="text-muted">{selected.created_by}</p>
						</div>
						<div>
							<p className="font-weight-bold mt-2" style={{ color: 'black' }}>Created Date</p>
							<p className="text-muted">{moment(selected.createdAt).format('DD/MM/YYYY')}</p>
						</div>
					</div>
					<div className="d-flex justify-content-center">
						<HighlightTabs items={tabslist} tab={tab} setTab={setTab} />
					</div>
				</DialogTitle>
				<DialogContent className="mx-0">
					<div className="d-flex justify-content-between w-100">
						{{
							1: <Stage1Content data={selected?.NonConformityReportFiles.find(e => e.stage === tab)} />,
							2: <Stage2Content data={selected?.NonConformityReportFiles.find(e => e.stage === tab)} />,
							3: <Stage3Content data={selected?.NonConformityReportFiles.find(e => e.stage === tab)} />,
							4: <Stage4Content data={selected?.NonConformityReportFiles.find(e => e.stage === tab)} />,
							5: <Stage5Content data={selected?.NonConformityReportFiles.find(e => e.stage === tab)} />,
							6: <Stage6Content data={selected?.NonConformityReportFiles.find(e => e.stage === tab)} />,
						}[tab]}
					</div>
				</DialogContent>
				<DialogActions className="mb-1">
					<Button onClick={handleClose}>
						CLOSE
					</Button>
				</DialogActions>
			</Dialog>
		</MuiThemeProvider>
	);
};

const getMuiTheme = () => createTheme({
	typography: {
		fontFamily: 'CeraProRegular',
	},
});

const Stage1Content = ({ data }) => {
	return (
		<div className='d-flex w-100 justify-content-center mt-2'>
			<div className="w-50" style={{ border: '0.5px solid grey', borderRadius: 10 }}>
				{[
					{ title: 'House / Unit', value: data.details.unit || '-' },
					{ title: 'Level', value: data.details.level || '-' },
					{ title: 'Block', value: data.details.block || '-' },
					{ title: 'Date', value: moment(data.details.reportDate, 'YYYY-M-D k:m:s').format('DD/MM/YYYY hh:mm A') || '-' },
					{ title: 'Description', value: data.details.description || '-' },
					{ title: 'Signature', value: <img src={data.signature} className="w-50" /> || '-' },
				].map((e, idx) => (
					<div className="d-flex justify-content-between px-4 py-2" style={{ borderTop: !!idx && '0.5px solid grey' }}>
						<p style={{ color: 'grey' }}>{e.title}</p>
						<p className="font-weight-bolder" style={{ width: '60%' }}>{e.value}</p>
					</div>
				))}
			</div>
		</div>
	)
};

const Stage2Content = ({ data }) => {
	return (
		<div className='d-flex w-100 justify-content-center mt-2'>
			<div className="w-50" style={{ border: '0.5px solid grey', borderRadius: 10 }}>
				{[
					{ title: 'Category', value: data.details.category || '-' },
					{ title: 'Corrective Action to be Taken', value: data.details.correctiveAction || '-' },
					{ title: 'Other Purpose', value: data.details.specifyReason || '-' },
					{ title: `${data.details.filesImage.length} images uploaded`, value: !!data.details.filesImage.length ? data.details.filesImage.map(e => (<img src={`${process.env.REACT_APP_S3}/${e}`} className="w-50" />)) : 'No Image' },
					{ title: `${data.details.filesDrawing.length} drawing uploaded`, value: !!data.details.filesDrawing.length ? data.details.filesDrawing.map(e => (<img src={`${process.env.REACT_APP_S3}/${e}`} className="w-50" />)) : 'No Drawing' },
					{ title: `${data.details.files.length} files uploaded`, value: !!data.details.files.length ? data.details.files.map(e => (<img src={`${process.env.REACT_APP_S3}/${e}`} className="w-50" />)) : 'No File' },
					{ title: 'Verified By', value: data.details.verified_by || '-' },
					{ title: 'Signature', value: <img src={data.signature} className="w-50" /> || '-' },
				].map((e, idx) => (
					<div className="d-flex justify-content-between px-4 py-2" style={{ borderTop: !!idx && '0.5px solid grey' }}>
						<p style={{ color: 'grey', width: '40%' }}>{e.title}</p>
						<p className="font-weight-bolder" style={{ width: '60%' }}>{e.value}</p>
					</div>
				))}
			</div>
		</div>
	)
};

const Stage3Content = ({ data }) => {
	return (
		<div className='d-flex w-100 justify-content-center mt-2'>
			<div className="w-50" style={{ border: '0.5px solid grey', borderRadius: 10 }}>
				{[
					{ title: 'Verified By', value: data.details.verified_by || '-' },
					{ title: 'Signature', value: <img src={data.signature} className="w-50" /> || '-' },
				].map((e, idx) => (
					<div className="d-flex justify-content-between px-4 py-2" style={{ borderTop: !!idx && '0.5px solid grey' }}>
						<p style={{ color: 'grey', width: '40%' }}>{e.title}</p>
						<p className="font-weight-bolder" style={{ width: '60%' }}>{e.value}</p>
					</div>
				))}
			</div>
		</div>
	)
};


const Stage4Content = ({ data }) => {
	return (
		<div className='d-flex w-100 justify-content-center mt-2'>
			<div className="w-50" style={{ border: '0.5px solid grey', borderRadius: 10 }}>
				{[
					{ title: 'Cause of Non-Conformance', value: data.details.category || '-' },
					{ title: 'Corrective Action', value: data.details.correctiveAction || '-' },
					{ title: `${data.details.filesImage.length} images uploaded`, value: !!data.details.filesImage.length ? data.details.filesImage.map(e => (<img src={`${process.env.REACT_APP_S3}/${e}`} className="w-50" />)) : 'No Image' },
					{ title: `${data.details.files.length} files uploaded`, value: !!data.details.files.length ? data.details.files.map((e, idx) => (<p><a href={`${process.env.REACT_APP_S3}/${e}`} target="_blank">{`File ${idx + 1}`}</a></p>)) : 'No File' },
					{ title: 'Signature', value: <img src={data.signature} className="w-50" /> || '-' },
				].map((e, idx) => (
					<div className="d-flex justify-content-between px-4 py-2" style={{ borderTop: !!idx && '0.5px solid grey' }}>
						<p style={{ color: 'grey', width: '40%' }}>{e.title}</p>
						<p className="font-weight-bolder" style={{ width: '60%' }}>{e.value}</p>
					</div>
				))}
			</div>
		</div>
	)
};

const Stage5Content = ({ data }) => {
	return (
		<div className='d-flex w-100 justify-content-center mt-2'>
			<div className="w-50" style={{ border: '0.5px solid grey', borderRadius: 10 }}>
				{[
					{ title: 'Inspection Date', value: moment(data.details.reportDate).format('DD/MM/YYYY hh:mm A') || '-' },
					{ title: 'Signature', value: <img src={data.signature} className="w-50" /> || '-' },
				].map((e, idx) => (
					<div className="d-flex justify-content-between px-4 py-2" style={{ borderTop: !!idx && '0.5px solid grey' }}>
						<p style={{ color: 'grey', width: '40%' }}>{e.title}</p>
						<p className="font-weight-bolder" style={{ width: '60%' }}>{e.value}</p>
					</div>
				))}
			</div>
		</div>
	)
};

const Stage6Content = ({ data }) => {
	return (
		<div className='d-flex w-100 justify-content-center mt-2'>
			<div className="w-50" style={{ border: '0.5px solid grey', borderRadius: 10 }}>
				{[
					{ title: 'Comment', value: data.details.comment || '-' },
					{ title: 'Inspection Date', value: moment(data.details.reportDate).format('DD/MM/YYYY hh:mm A') || '-' },
					{ title: 'Verified By', value: data.details.verified_by || '-' },
					{ title: 'Signature', value: <img src={data.signature} className="w-50" /> || '-' },
				].map((e, idx) => (
					<div className="d-flex justify-content-between px-4 py-2" style={{ borderTop: !!idx && '0.5px solid grey' }}>
						<p style={{ color: 'grey', width: '40%' }}>{e.title}</p>
						<p className="font-weight-bolder" style={{ width: '60%' }}>{e.value}</p>
					</div>
				))}
			</div>
		</div>
	)
};